export const ROOTNAME_XLOGS = "xlogs";

const TAB_STUDENTS = "students";
const TAB_ADMIN = "admin";
const TAB_REPORTS = "reports";
const TAB_MSB = "msb";

export const ROUTES_XLOGS = {
  fortitude: `/${ROOTNAME_XLOGS}/fortitude`,
  notator: `/${ROOTNAME_XLOGS}/notator`,
  thirtyDayReview: `/${ROOTNAME_XLOGS}/30-day-review`,
  summary: `/${ROOTNAME_XLOGS}/summary`,
  calendar: `/${ROOTNAME_XLOGS}/calendar`,
  students: `/${ROOTNAME_XLOGS}/${TAB_STUDENTS}`,
  _students: {
    manager: `/${ROOTNAME_XLOGS}/${TAB_STUDENTS}/manager`,
    groups: `/${ROOTNAME_XLOGS}/${TAB_STUDENTS}/groups`,
    profile: `/${ROOTNAME_XLOGS}/${TAB_STUDENTS}/manager/:studentID`,
  },
  reports: {
    index: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}`,
    sessionLogs: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/session-logs`,
    serviceReport: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/session-logs/session-logs-report`,
    accountStudentReport: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/account-student-report`,
    unpostedSessionsReport: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/unposted-sessions-report`,
    progressReport: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/progress-report`,
    progressSummary: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/progress-summary`,
    instanceReport: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/instance-report`,
    // V2 Session Logs (new reporting backend)
    sessionLogsV2: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/session-logs-v2`,
    sessionLogsV2Report: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/session-logs-v2/report`,
    // V2 Account Student Report (new reporting backend)
    accountStudentReportV2: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/account-student-report-v2`,
    // V2 Unposted Sessions (new reporting backend)
    unpostedSessionsV2: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/unposted-sessions-v2`,
    // V2 Student Progress (new reporting backend)
    studentProgressV2: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/student-progress-v2`,
    studentProgressV2Summary: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/student-progress-v2/summary`,
    studentProgressV2Edit: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/student-progress-v2/edit`,
    // 30 Day Review report (XLOGS-462; NH-only, new reporting backend)
    thirtyDayReviewReport: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/30-day-review-report`,
    thirtyDayReviewReportResults: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/30-day-review-report/report`,
    // Shared My Exports (used by all V2 reports)
    myExports: `/${ROOTNAME_XLOGS}/${TAB_REPORTS}/my-exports`,
  },
  analytics: `/${ROOTNAME_XLOGS}/analytics`,
  admin: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}`,
  user: `/${ROOTNAME_XLOGS}/my-profile`,
  // The account-agnostic MSB operator zone (XLOGS-205): internal surfaces
  // gated on the msb_role ladder, never on client assignments.
  msb: `/${ROOTNAME_XLOGS}/${TAB_MSB}`,
  _msb: {
    index: `/${ROOTNAME_XLOGS}/${TAB_MSB}`,
    bundles: `/${ROOTNAME_XLOGS}/${TAB_MSB}/bundles`,
    ediFiles: `/${ROOTNAME_XLOGS}/${TAB_MSB}/edi-files`,
    claims: `/${ROOTNAME_XLOGS}/${TAB_MSB}/claims`,
    claimDetail: `/${ROOTNAME_XLOGS}/${TAB_MSB}/claims/:claimId`,
    denials: `/${ROOTNAME_XLOGS}/${TAB_MSB}/denials`,
    remittances: `/${ROOTNAME_XLOGS}/${TAB_MSB}/remittances`,
    remittanceDetail: `/${ROOTNAME_XLOGS}/${TAB_MSB}/remittances/:remittanceId`,
    intakeReviews: `/${ROOTNAME_XLOGS}/${TAB_MSB}/intake-reviews`,
    corrections: `/${ROOTNAME_XLOGS}/${TAB_MSB}/corrections`,
    districts: `/${ROOTNAME_XLOGS}/${TAB_MSB}/districts`,
    districtDetail: `/${ROOTNAME_XLOGS}/${TAB_MSB}/districts/:districtId`,
    billingExclusions: `/${ROOTNAME_XLOGS}/${TAB_MSB}/billing-exclusions`,
    configuration: `/${ROOTNAME_XLOGS}/${TAB_MSB}/configuration`,
    configurationKey: `/${ROOTNAME_XLOGS}/${TAB_MSB}/configuration/:key`,
    billingCatalog: `/${ROOTNAME_XLOGS}/${TAB_MSB}/billing-catalog`,
    billingRates: `/${ROOTNAME_XLOGS}/${TAB_MSB}/billing-rates`,
    ediGlossary: `/${ROOTNAME_XLOGS}/${TAB_MSB}/edi-glossary`,
    billingTest: `/${ROOTNAME_XLOGS}/${TAB_MSB}/billing-test`,
    imports: `/${ROOTNAME_XLOGS}/${TAB_MSB}/imports`,
  },
  _admin: {
    index: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}`,
    mydistrictProfile: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/my-district-profile`,
    userApproval: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/user-approval`,
    staffDirectoryManager: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/staff-directory-manager`,
    campusManagement: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/campus-management`,
    studentMerge: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/student-merge`,
    billableServices: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/billable-services`,
    prescribingProvider: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/prescribing-provider`,
    approverCaseloads: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/approver-caseloads`,
    decCaseloads: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/dec-caseloads`,
    calendarManagement: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/calendar-management`,
    schoolCalendar: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/calendar-management/school-calendar`,
    studentManagement: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/student-management`,
    unassignedStudents: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/unassigned-students`,
    transportationAccommodations: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/transportation-accommodations`,
    goodFaithEffort: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/good-faith-effort`,
    billingWorklist: `/${ROOTNAME_XLOGS}/${TAB_ADMIN}/billing-worklist`,
  },
  unposted_sessions: {
    index: `/${ROOTNAME_XLOGS}/unposted-sessions`,
    mySessions: `/${ROOTNAME_XLOGS}/unposted-sessions/my-sessions`,
    decSessions: `/${ROOTNAME_XLOGS}/unposted-sessions/dec-sessions`,
    assistantSessions: `/${ROOTNAME_XLOGS}/unposted-sessions/assistant-sessions`,
    notator: `/${ROOTNAME_XLOGS}/unposted-sessions/:viewId/notator/:sessionId`,
    batch_post: `/${ROOTNAME_XLOGS}/unposted-sessions/:viewId/batch-post`,
  },
};
